
/*
  This file is auto-generated and ignored by git in order to
  provide back-links to GitHub source. See pregenerate.js
*/

export default {
  "local": false,
  "branch": "release-v1.4.x",
  "url": "https://github.com/learningequality/kolibri-design-system/tree/release-v1.4.x"
};
